import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { jwtDecode } from "jwt-decode";
import { useCookies } from "react-cookie";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  // const [permissions, setPermissions] = useState([]);
  const [packageTypes, setPackageTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cookies, setCookie, removeCookie] = useCookies(["jwt"]);

  const logout = useCallback(() => {
    setUser(null);
    setRole(null);
    const maxAge = 7 * 24 * 60 * 60;
    // setPermissions([]);
    setPackageTypes([]);
    removeCookie("jwt", {
      path: "/",
      httpOnly:false,
      secure: process.env.NODE_ENV === "production",
      sameSite: process.env.NODE_ENV === "production" ? "Lax" : "None",
      domain:"prod.thequikpawn.com",
      maxAge: maxAge * 1000
    });
    setLoading(false);
  }, [removeCookie]);
  console.log("user ========>", user);
  useEffect(() => {
    const token = cookies.jwt;
    console.log("token =>", token);
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        const now = Date.now();

        // console.log("decodedToken", decodedToken);

        if (now >= decodedToken.exp * 1000) {
          logout();
        } else {
          setUser(decodedToken);
          setRole(decodedToken.role);
          // setPermissions(decodedToken.permissions);

          const companyData = decodedToken.companyData || [];
          const types = companyData.map((company) => company.package_type_id);
          setPackageTypes(types);

          const timeUntilExpiration = decodedToken.exp * 1000 - now;
          const timeoutId = setTimeout(() => {
            logout();
          }, timeUntilExpiration);

          setLoading(false);

          return () => clearTimeout(timeoutId);
        }
      } catch (error) {
        console.error("Failed to decode token:", error);
        logout();
      }
    } else {
      setLoading(false);
    }
  }, [cookies.jwt, logout]);

  useEffect(() => {
    // Check if user state is set and loading state is false
    if (user) {
      setLoading(false);
    }
  }, [user]);

  const login = (token, navigate) => {
    try {
      const decodedToken = jwtDecode(token);
      setUser(decodedToken);
      setRole(decodedToken.role);
      // setPermissions(decodedToken.permissions);

      const companyData = decodedToken.companyData || [];
      const types = companyData.map((company) => company.package_type_id);

      const typeExists = new Set(types);

      setPackageTypes([...typeExists]);

      if (
        decodedToken.role == "SuperAdminA" ||
        decodedToken.role == "SuperAdminM"
      ) {
        navigate("/admin");
      } else if (types.includes(1)) {
        navigate("/pawn");
      } else if (types.includes(2)) {
        navigate("/car");
      } else if (types.includes(3)) {
        navigate("/land");
      } else {
        navigate("/error");
      }
    } catch (error) {
      console.error("Failed to decode token:", error);
      logout();
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        role,
        // permissions,
        login,
        logout,
        loading,
        packageTypes,
        setLoading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
